var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['bi-tip-message-box', _vm.isShow ? 'message-show' : '']},[_c('div',{staticClass:"bi-tip-message-content",style:(_vm.tipStyle)},[_vm._v("\n    "+_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }